/**
 * Translate gender values to Vietnamese
 */
export const getGenderInVietnamese = (gender: string): string => {
  const genderMap: Record<string, string> = {
    'Male': 'Nam',
    'Female': 'Nữ',
    'Other': 'Khác'
  };

  return genderMap[gender] || gender;
};
